import React from 'react';
import { Card } from 'semantic-ui/semantic-ui-imports';
import './index.scss';

interface Props {
  name: string;
  text: string;
  img: string;
  alt: string;
}

const TextAndPicture = ({ name, text, img, alt }: Props) => (
  <Card className="text-and-picture">
    <div className="text-and-picture__inner">
      <div className="text-and-picture__inner__description">
        <b>{name}</b>
        <p>{text}</p>
      </div>
      <div className="text-and-picture__inner__img">
        {img && <img src={img} alt={alt} />}
      </div>
    </div>
  </Card>
);

export default TextAndPicture;
